<template>
  <div style="display: flex;flex-direction: row">
    <span v-for="(item, index) in filteredList" :key="index">
     {{ item[value] }}{{memberUnit?'-'+item[memberUnit]:''}}
    </span>
  </div>
</template>
<script>
export default {
  name: 'MembersTag',
  props: {
    list: {
      type: Array,
      required: true
    },
    prop: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    memberUnit: {
      type: String,
      required: true
    },
    keytag: {
      type: [String, Number]
    }
  },
  computed: {
    // 过滤列表，只保留符合 key 的项
    filteredList () {
      if (this.list && this.list.length > 0) {
        var info = this.list.filter(item => item[this.prop] === this.keytag)
        if (info && info.length > 0) {
          return info
        } else {
          return []
        }
      } else {
        return []
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/MembersTag/index.vue